import { Router } from '@angular/router';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../app.service';
import { Home6Service } from '../home/home.service';
import { Rate } from '../home/home';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { Utilities } from '../shared/utilities';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  // encapsulation : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {

  // HealthCareInsurance
  HealthCareInsurance
  HealthCareInsuranceValue
  // Doctors
  Doctors;
  DoctorsValue
  DoctorsTopRated
  // MedicalServices
  MedicalServices
  MedicalServicesValue
  // Location
  longitudeValue
  latitudeValue

  homeServicesRes

  LatestBlogs

  title = 'rou';
  formattedaddress = null;
  options = {
    componentRestrictions: {
      country: ["JO"]
    },
    types: ['neighborhood', 'sublocality_level_1', 'locality', 'administrative_area_level_1', 'administrative_area_level_2']
    // types: ['neighborhood', 'sublocality_level_1','locality','administrative_area_level_1']
  }

  constructor(
    private service: Home6Service,
    public app: AppService,
    public translate: TranslateService,
    public route: Router,
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }


  ngOnInit(): void {
    this.app.showLoading();
    this.getdata();
    this.slideConfig();
  }


  getdata() {
    // this.getHealthCareInsurance();
    // this.getMedicalServices();
    this.getInitHome();
    this.homeServices();
    this.getAllLocations();
    // if (isPlatformBrowser(this.platformId)) {
    //   this.cacheLookUps();
    // }
    // this.getBestDoctors();
    // this.getLatestBlogs();

    this.app.dismissLoading();
  }

  // DebounceForDoctorName
  inputBeforeDoc: string = "Doctor Name"
  docsLoading = false;
  debounceForDocName(event: any) {
    this.docsLoading = true
    this.cd.detectChanges();
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const docSelect = ((document.getElementById("docSelect") as HTMLInputElement).value);
        if (docSelect.length >= 2 && this.inputBeforeDoc != docSelect) {
          this.getDoctorsDebounce(docSelect)
          this.inputBeforeDoc = docSelect
          this.cd.detectChanges();
        } else {
          this.docsLoading = false
          this.cd.detectChanges();
          return
        }
        this.cd.detectChanges();
      }, 500);
    }
  }

  getDoctorsDebounce = (term) => {
    this.service.getDoctors({
      searchText: term,
      pageSize: 50,
      pageNumber: 1,
    }).subscribe(res => {
      this.Doctors = res.data.data;
      this.cd.detectChanges();
    })
    this.docsLoading = false
    this.cd.detectChanges();
  }
  // /DebounceForDoctorName

  // SlideSettings
  slideConfig() {
    if (this?.app?.getUserLanguage() == 'ar') {
      this.slideConfigureForDoctor.rtl = true
    }
  }
  slideConfigureForDoctor = {
    dots: false,
    autoplay: true,
    infinite: true,
    variableWidth: false,
    draggable: true,
    rtl: false,
    arrows: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1333,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  // /SlideSettings



  public AddressChange(address: any) {
    this.formattedaddress = null
    if (isPlatformBrowser(this.platformId)) {
      if (address) {
        if (address.address_components) {
          const typesToKeep = ['neighborhood', 'sublocality_level_1', 'locality', 'country'];
          const filteredArray = address.address_components.filter(location => location.types.some(type => typesToKeep.includes(type)));

          const countryObj = filteredArray.find(obj => obj.types.includes('country') && obj.types.includes('political'));
          const countryLongName = countryObj?.long_name;

          const govObj = filteredArray.find(obj => obj.types.includes('locality') && obj.types.includes('political'));
          const govLongName = govObj?.long_name;

          const districtObj = filteredArray.find(obj => obj.types.includes('sublocality_level_1') && obj.types.includes('sublocality') && obj.types.includes('political'));
          const districtLongName = districtObj?.long_name;

          let comb;
          if (districtLongName) {
            comb = `${districtLongName} ${govLongName} ${countryLongName}`
          } else {
            comb = `${govLongName} ${countryLongName}`
          }

          // this.formattedaddress = address?.formatted_address;
          this.formattedaddress = comb;
        }
        this.longitudeValue = (address?.geometry?.location.lng());
        this.latitudeValue = (address?.geometry?.location.lat());
      }
    }
  }

  searchDoctorsOld = () => {
    let defaultLoc = this?.app?.languageCode == 'ar' ? 'الأردن' : 'jordan'
    let medicalS = this?.app?.languageCode == 'ar' ? 'جميع-التخصصات' : 'all-specialities'
    let locationS = this.formattedaddress ? this.formattedaddress : defaultLoc


    if (this.formattedaddress) {
      let k = this?.formattedaddress.replace(/ /gi, '-');
      locationS = k?.replace(/[()،,.+]/gi, '');
    }

    if (this.MedicalServicesValue) {
      let a = this.MedicalServices.find(x => x.id == this.MedicalServicesValue)
      medicalS = a?.name?.replace(/ /gi, '-');
      medicalS = medicalS?.replace(/-{2,}/g, '-');
      medicalS = medicalS?.replace(/[()،,.]/gi, '');
    }

    let params = {
      'searchText': this.DoctorsValue,
      'longitude': this.longitudeValue,
      'latitude': this.latitudeValue,
      'insuranceCompanyIds': this.HealthCareInsuranceValue,
    }

    let str = [];

    for (let p in params) {
      if (!params[p]) { continue }
      str.push(Utilities.encrypt(p.toString()) + "=" + Utilities.encrypt(params[p]?.toString()));
    }

    if (str.length > 0) {
      this.route.navigate([`/${this?.app?.languageCode}/search-doctor/${medicalS}/${locationS}`], {
        queryParams: {
          'XYZ': str.join("&&"),
        }
      });
    } else {
      this.route.navigate([`/${this?.app?.languageCode}/search-doctor/${medicalS}/${locationS}`]);
    }

  }

  searchDoctorsNew = () => {
    let medicalS = this?.app?.languageCode == 'ar' ? 'جميع-التخصصات' : 'all-specialities'
    let insuranceS = this?.app?.languageCode == 'ar' ? 'جميع-التأمينات' : 'all-insurance'
    let country = this?.app?.languageCode == 'ar' ? 'الأردن' : 'jordan'
    let city = this?.app?.languageCode == 'ar' ? 'جميع-المحافظات' : 'all-governorates'
    let area = this?.app?.languageCode == 'ar' ? 'جميع-المناطق' : 'all-areas'

    if (this.MedicalServicesValue) {
      let a = this.MedicalServices.find(x => x.id == this.MedicalServicesValue)
      // medicalS = a?.name?.replace(/ /gi, '-');
      // medicalS = medicalS?.replace(/-{2,}/g, '-');
      // medicalS = medicalS?.replace(/[()،,.]/gi, '');
      medicalS = this?.app?.generateSlug(a?.name);
    }

    if (this.HealthCareInsuranceValue) {
      let a = this.HealthCareInsurance.find(x => x.id == this.HealthCareInsuranceValue)
      // insuranceS = a?.name?.replace(/ /gi, '-');
      // insuranceS = insuranceS?.replace(/-{2,}/g, '-');
      // insuranceS = insuranceS?.replace(/[()،,.]/gi, '');
      insuranceS = this?.app?.generateSlug(a?.name);
    }

    if (this.allLocationsValues) {
      let a = this.allLocations.find(x => x.id == this.allLocationsValues)
      if (a?.parentId == 0) {
        // city = a?.name?.replace(/ /gi, '-');
        // city = city?.replace(/-{2,}/g, '-');
        // city = city?.replace(/[()،,.]/gi, '');
        city = this?.app?.generateSlug(a?.name);
      } else if (a?.parentId != 0) {
        // city = a?.parentName?.replace(/ /gi, '-');
        // city = city?.replace(/-{2,}/g, '-');
        // city = city?.replace(/[()،,.]/gi, '');
        city = this?.app?.generateSlug(a?.parentName);

        // area = a?.name?.replace(/ /gi, '-');
        // area = area?.replace(/-{2,}/g, '-');
        // area = area?.replace(/[()،,.]/gi, '');
        area = this?.app?.generateSlug(a?.name);
      }
    }

    // params
    let params = {
      'searchText': this.DoctorsValue,
      // 'insuranceCompanyIds': this.HealthCareInsuranceValue,
    }
    let str = [];
    for (let p in params) {
      if (!params[p]) { continue }
      str.push(Utilities.encrypt(p.toString()) + "=" + Utilities.encrypt(params[p]?.toString()));
    }
    // params

    if (str.length > 0) {
      this.route.navigate([`/${this?.app?.languageCode}/search/${medicalS}/${country}/${city}/${area}/${insuranceS}`], {
        queryParams: {
          'XYZ': str.join("&&"),
        }
      });
    } else {
      this.route.navigate([`/${this?.app?.languageCode}/search/${medicalS}/${country}/${city}/${area}/${insuranceS}`]);
    }

  }

  // ForSkeletonLoading
  // loadImageForBestDoctors(e) {
  //   if (!this.imgLoadForDoctors) {
  //     this.imgLoadForDoctors = true;
  //   }
  // }

  // loadImageForBlogs(e) {
  //   if (!this.imgLoadForBlogs) {
  //     this.imgLoadForBlogs = true;
  //   }
  // }
  // ForSkeletonLoading

  // SubFunctions
  isProbablyArabic(str: string): boolean {
    var Character
    for (var i = 0; i < 5; i++) {
      let c = str.codePointAt(i);
      if (c >= 0x0600 && c <= 0x06E0)
        return true;
    }
    return false;
  }

  getStarString(numStars: number): string {
    Number(numStars)
    if (numStars > 5) {
      throw new Error('Invalid number of stars. Please provide a number between 1 and 5.');
    }
    const stars: string[] = ['', '⭐', '⭐⭐', '⭐⭐⭐', '⭐⭐⭐⭐', '⭐⭐⭐⭐⭐'];

    return stars[numStars];
  }
  // /SubFunctions



  // apiServices

  getInitHome() {
    this.service.getInitData().subscribe(
      res => {
        // LookUps
        let y = res?.medicalServices?.filter(x => x.classification == 3)
        this.MedicalServices = y
        this.HealthCareInsurance = res?.insuranceCompanies
        // LookUps

        // bestDoctors&Last3Blogs
        this.LatestBlogs = res.blogs
        this.DoctorsTopRated = res.hcp
        // this.DoctorsTopRated = res?.hcp?.map(x => {
        //   if (x.rate) {
        //     x.rate = this.getStarString(x.rate)
        //   } else {
        //     x.rate = this.getStarString(0)
        //   }
        //   return x
        // })

        this.cd.detectChanges();
      }
    )
  }

  homeServices() {
    this.service.homeServices().subscribe(
      res => {
        this.homeServicesRes = res?.data?.data
        this.cd.detectChanges();
      }
    )
  }


  allLocations;
  allLocationsValues;
  getAllLocations = () => {
    this.service.getAllLocations().subscribe(res => {
      if (res.errorCode == 0) {
        // this.allLocations = res.data
        this.allLocations = res?.data?.map(item => {
          if (item?.parentName) {
            item.nameForSelect = `${item?.parentName} - ${item?.name}`
            return item
          } else {
            item.nameForSelect = item?.name
            return item
          }
        })
        this.cd.detectChanges();
      }
    })
  }

  getMedicalServices = () => {
    this.service.getMedicalServices().subscribe(res => {
      if (res.errorCode == 0) {
        let y = res.data.filter(x => x.classification == 3)
        this.MedicalServices = y
        // if (isPlatformBrowser(this.platformId)) {
        //   sessionStorage.setItem(environment.appName + "MedicalServices", JSON.stringify(y));
        // }
        // this.MedicalServicesSection = res.data.filter((res) => res.parentServiceId == 0 && res.sortIndex != 0 && res.id != 21)
        this.cd.detectChanges();
      }
    })
  }

  getHealthCareInsurance = () => {
    this.service.getHealthCareInsurance({ pageSize: 9999, pageNumber: 1 }).subscribe(res => {
      this.HealthCareInsurance = res.data.data;
      // if (isPlatformBrowser(this.platformId)) {
      //   sessionStorage.setItem(environment.appName + "HealthCareInsurance", JSON.stringify(res.data.data))
      // }
      this.cd.detectChanges();
    })

  }

  getBestDoctors = () => {
    this.service.getDoctors({
      pageSize: 8,
      pageNumber: 10,
      rate: Rate.FiveToZero,
    }).subscribe(res => {
      // this.DoctorsTopRated = res.data.data.slice(50,58)
      this.DoctorsTopRated = res.data.data
      this.cd.detectChanges();
    })
  }

  getLatestBlogs = () =>
    this.service.getLatestBlogs("PageSize=3&PageNumber=1").subscribe(
      res => {
        if (res.errorCode == 0) {
          this.LatestBlogs = res.data.data
          this.cd.detectChanges();
        }
      }
    )
  // /apiServices

  // handle if looksUps cached or not
  cacheLookUps() {
    // WAS to handle cached lookUps(so it does not hit apis for performance, but feature deleted for SSR,SEO)
    return
    if (!this.app.getInsuranceSS()) {
      this.getHealthCareInsurance();
    } else if (this.app.getInsuranceSS()) {
      let y = this?.app?.getInsuranceSS()
      let x = this.app.getUserLanguage()
      if (this.isProbablyArabic(y[0]?.name) && x == 'ar' || !this.isProbablyArabic(y[0]?.name) && x == 'en') {
        this.HealthCareInsurance = this?.app?.getInsuranceSS()
      } else {
        this.getHealthCareInsurance();
      }
    }

    if (!this.app.getMedicalServiceSS()) {
      this.getMedicalServices();
    } else if (this.app.getMedicalServiceSS()) {
      let y = this?.app?.getMedicalServiceSS()
      let x = this.app.getUserLanguage()
      if (this.isProbablyArabic(y[0]?.name) && x == 'ar' || !this.isProbablyArabic(y[0]?.name) && x == 'en') {
        this.MedicalServices = this?.app?.getMedicalServiceSS()
      } else {
        this.getMedicalServices();
      }
    }

  }

  routeToServiceDetails(id) {
    this.route.navigate([`/${this?.app?.languageCode}/service-details/${id}`]);
  }

}


